import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import BulkUpdateCategoryForm from "./BulkUpdateCategoryForm";

const BulkUpdateCategoryModal = ({ open, onOpenChange, tagIds, onSuccess }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Bulk Update Category</DialogTitle>
      </DialogHeader>
      {open && (
        <BulkUpdateCategoryForm
          tagIds={tagIds}
          onSuccess={onSuccess}
          onCancel={() => onOpenChange(false)}
        />
      )}
    </DialogContent>
  </Dialog>
);

export default BulkUpdateCategoryModal;
